import { useTranslation } from "react-i18next";

export default function SeoContentSections() {
  const { t } = useTranslation();

  const steps = [
    { number: "1", title: t("section3_step1_title"), desc: t("section3_step1_desc") },
    { number: "2", title: t("section3_step2_title"), desc: t("section3_step2_desc") },
    { number: "3", title: t("section3_step3_title"), desc: t("section3_step3_desc") },
    { number: "4", title: t("section3_step4_title"), desc: t("section3_step4_desc") },
  ];

  const whyCards = [
    {
      icon: "ri-grid-line",
      title: t("section2_card1_title"),
      desc: t("section2_card1_desc"),
      img: "https://readdy.ai/api/search-image?query=Organized%20product%20catalog%20grid%20with%20fashion%20items%20neatly%20arranged%20on%20white%20surface%2C%20overhead%20flat%20lay%20photography%2C%20clean%20minimalist%20aesthetic%2C%20soft%20natural%20light%2C%20warm%20cream%20and%20beige%20tones%2C%20editorial%20product%20display%2C%20modern%20organized%20composition%2C%20professional%20quality&width=600&height=400&seq=why-card-product-grid-v2&orientation=landscape",
    },
    {
      icon: "ri-folder-open-line",
      title: t("section2_card2_title"),
      desc: t("section2_card2_desc"),
      img: "https://readdy.ai/api/search-image?query=Colorful%20labeled%20category%20folders%20and%20tags%20spread%20across%20light%20wooden%20desk%2C%20organized%20fashion%20moodboard%20concept%2C%20soft%20diffused%20daylight%2C%20clean%20modern%20aesthetic%2C%20pastel%20sage%20and%20warm%20coral%20accents%2C%20editorial%20stationery%20photography%2C%20bright%20airy%20atmosphere&width=600&height=400&seq=why-card-categories-v2&orientation=landscape",
    },
    {
      icon: "ri-timer-line",
      title: t("section2_card3_title"),
      desc: t("section2_card3_desc"),
      img: "https://readdy.ai/api/search-image?query=Minimalist%20clock%20and%20checklist%20on%20clean%20white%20marble%20surface%2C%20time%20saving%20concept%2C%20soft%20morning%20light%2C%20fresh%20modern%20aesthetic%2C%20sage%20green%20and%20cream%20palette%2C%20editorial%20productivity%20photography%2C%20elegant%20simple%20composition%2C%20calm%20organized%20atmosphere&width=600&height=400&seq=why-card-timesave-v2&orientation=landscape",
    },
    {
      icon: "ri-stack-line",
      title: t("section2_card4_title"),
      desc: t("section2_card4_desc"),
      img: "https://readdy.ai/api/search-image?query=Side%20by%20side%20product%20comparison%20display%20on%20white%20table%2C%20two%20similar%20fashion%20items%20arranged%20neatly%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20product%20photography%2C%20minimalist%20aesthetic%2C%20warm%20neutral%20background%2C%20professional%20composition%2C%20balanced%20organized%20layout&width=600&height=400&seq=why-card-compare-v2&orientation=landscape",
    },
  ];

  return (
    <>
      <section id="what-is" className="py-16 md:py-24 bg-background-50">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <div className="max-w-[720px] mx-auto text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-5">
              {t("section1_title")}
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              {t("section1_text1")}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {t("section1_text2")}
            </p>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full max-w-[720px] mx-auto border-collapse">
              <thead>
                <tr className="border-b border-foreground-200">
                  <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-800">{t("section1_table_header1")}</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-800">{t("section1_table_header2")}</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-800">{t("section1_table_header3")}</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-800">{t("section1_table_header4")}</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-foreground-100">
                  <td className="py-3 px-4 text-sm text-foreground-700">{t("section1_method1")}</td>
                  <td className="py-3 px-4 text-sm text-foreground-600 text-center">langsam</td>
                  <td className="py-3 px-4 text-sm text-foreground-600 text-center">schlecht</td>
                  <td className="py-3 px-4 text-sm text-foreground-600 text-center">nein</td>
                </tr>
                <tr className="border-b border-foreground-100">
                  <td className="py-3 px-4 text-sm text-foreground-700">{t("section1_method2")}</td>
                  <td className="py-3 px-4 text-sm text-foreground-600 text-center">mittel</td>
                  <td className="py-3 px-4 text-sm text-foreground-600 text-center">begrenzt</td>
                  <td className="py-3 px-4 text-sm text-foreground-600 text-center">teilweise</td>
                </tr>
                <tr>
                  <td className="py-3 px-4 text-sm text-primary-700 font-semibold">{t("section1_method3")}</td>
                  <td className="py-3 px-4 text-sm text-primary-600 text-center font-semibold">schnell</td>
                  <td className="py-3 px-4 text-sm text-primary-600 text-center font-semibold">sehr hoch</td>
                  <td className="py-3 px-4 text-sm text-primary-600 text-center font-semibold">ja</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background-100">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 text-center mb-10 md:mb-14">
            {t("section2_title")}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {whyCards.map((card) => (
              <div key={card.title} className="bg-background-50 rounded-xl overflow-hidden border border-foreground-100/30 group cursor-default">
                <div className="relative w-full aspect-[3/2] overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent" />
                </div>
                <div className="p-5 md:p-6 pt-4">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                    <i className={`${card.icon} text-primary-600 text-lg w-4 h-4 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{card.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background-50">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 text-center mb-10 md:mb-14">
            {t("section3_title")}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {steps.map((step) => (
              <div key={step.number} className="relative">
                <div className="bg-background-100 rounded-xl p-5 md:p-6 border border-foreground-100/30 h-full">
                  <div className="w-8 h-8 rounded-full bg-primary-500 text-white flex items-center justify-center text-sm font-bold mb-4">
                    {step.number}
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{step.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="comparison" className="py-16 md:py-24 bg-background-100">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 text-center mb-10 md:mb-14">
            {t("section4_title")}
          </h2>
          <div className="overflow-x-auto max-w-[720px] mx-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b border-foreground-200">
                  <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-800">{t("section4_function")}</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-primary-700">{t("section4_spreadsheet")}</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-700">{t("section4_normal")}</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-foreground-100">
                  <td className="py-3 px-4 text-sm text-foreground-700">{t("section4_row1")}</td>
                  <td className="py-3 px-4 text-sm text-primary-600 text-center"><i className="ri-check-line w-4 h-4 inline-flex items-center justify-center"></i></td>
                  <td className="py-3 px-4 text-sm text-foreground-500 text-center"><i className="ri-close-line w-4 h-4 inline-flex items-center justify-center"></i></td>
                </tr>
                <tr className="border-b border-foreground-100">
                  <td className="py-3 px-4 text-sm text-foreground-700">{t("section4_row2")}</td>
                  <td className="py-3 px-4 text-sm text-primary-600 text-center"><i className="ri-check-line w-4 h-4 inline-flex items-center justify-center"></i></td>
                  <td className="py-3 px-4 text-sm text-foreground-500 text-center"><i className="ri-close-line w-4 h-4 inline-flex items-center justify-center"></i></td>
                </tr>
                <tr className="border-b border-foreground-100">
                  <td className="py-3 px-4 text-sm text-foreground-700">{t("section4_row3")}</td>
                  <td className="py-3 px-4 text-sm text-primary-600 text-center font-semibold">{t("section4_row3_val1")}</td>
                  <td className="py-3 px-4 text-sm text-foreground-500 text-center">{t("section4_row3_val2")}</td>
                </tr>
                <tr>
                  <td className="py-3 px-4 text-sm text-foreground-700">{t("section4_row4")}</td>
                  <td className="py-3 px-4 text-sm text-primary-600 text-center font-semibold">{t("section4_row4_val1")}</td>
                  <td className="py-3 px-4 text-sm text-foreground-500 text-center">{t("section4_row4_val2")}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section id="security" className="py-16 md:py-24 bg-background-50">
        <div className="max-w-[720px] mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-6">
            {t("section5_title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8">
            {t("section5_text")}
          </p>
          <div className="flex flex-wrap justify-center gap-3 mb-6">
            {["Verkäufer prüfen", "QC Bilder verstehen", "Datenschutz", "Sichere Nutzung"].map((item) => (
              <span key={item} className="flex items-center gap-1.5 px-3 py-1.5 bg-background-100 rounded-full text-xs text-foreground-700 border border-foreground-100/30">
                <i className="ri-shield-check-line text-primary-600 w-3.5 h-3.5 flex items-center justify-center"></i>
                {item}
              </span>
            ))}
          </div>
          <p className="text-xs text-foreground-500 italic">
            {t("section5_disclaimer")}
          </p>
        </div>
      </section>
    </>
  );
}